import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconInputForm: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconInputForm"><Path d="M10.5 6.5H21.5V17.5H10.5" stroke="currentColor"/><Path d="M6.5 6.5H2.5V17.5H6.5" stroke="currentColor"/><Path d="M8.5 3V21" stroke="currentColor"/></CentralIconBase>;
});

export default IconInputForm;
